module.exports = __webpack_public_path__ + "img/ic_message.b7779450.svg";